<!-- <div class="container" style="max-width: 500px;">
    <form [formGroup]="loginForm" (ngSubmit)="loginPreview()">
        <div class="mb-3">
          <label for="username" class="form-label">Username</label>
          <input type="text" class="form-control" id="username" aria-describedby="usernameHelp" formControlName="username">
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input type="password" class="form-control" id="password" formControlName="password">
        </div>
        <button type="submit" class="btn btn-primary">Accedi</button>
    </form>
</div> -->


<!-- <div>                       
    <div class="modal-header">
        <h4 class="title-modal text-center" id="modal-basic-title" >Login</h4>
        <button type="button" class="btn btn-close" aria-label="Close" (click)="activeModal.dismiss('Close')"></button>
    </div>

    <div class="modal-body p-5">                        
        <div class="container">
            <small *ngIf="alert" class="text-danger">Attenzione! Username o password errati.</small>
            <form [formGroup]="loginForm" (ngSubmit)="login()">
                <div class="mb-3">
                  <label for="current_username" class="form-label">Username</label>
                  <input type="text" class="form-control" id="current_username" aria-describedby="usernameHelp" formControlName="username">
                </div>
                <div class="mb-3">
                  <label for="current_password" class="form-label">Password</label>
                  <input type="password" class="form-control" id="current_password" formControlName="password">
                </div>
                <button type="submit" class="btn btn-primary"
                    [ngClass]="{
                        'btn-success': loginForm.valid,
                        'btn-danger': loginForm.invalid && loginForm.dirty 
                    }"
                >Accedi</button>
            </form>
        </div>
    </div>
</div>   -->


<form [formGroup]="loginForm" (ngSubmit)="login()">
    <div class="mb-3">
        <label for="current_username" class="form-label">Username</label>
        <input type="text" class="form-control" id="current_username" aria-describedby="usernameHelp" formControlName="username">
    </div>
    <div class="mb-3">
        <label for="current_password" class="form-label">Password</label>
        <input type="password" class="form-control" id="current_password" formControlName="password">
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="!loginForm.valid">{{"AUTH.LOGIN_TITLE" | translate}}</button>
</form>
<small *ngIf="alert" class="text-danger">{{"BLOCK.LOGIN.ATTENTION_ERROR" | translate}}</small>